import React from 'react';
import { motion } from 'framer-motion';
const rows = [{
  sin: 'Sin hooks listos',
  costo: 'Reels que no detienen el scroll'
}, {
  sin: 'Sin scripts',
  costo: 'Horas perdidas pensando qué decir'
}, {
  sin: 'Sin CTAs claros',
  costo: 'Seguidores que no saben cómo comprarte'
}, {
  sin: 'Sin sistema de DMs',
  costo: 'Leads que compran en otra tienda'
}, {
  sin: 'Sin calendario',
  costo: 'El mismo caos el mes que viene'
}, {
  sin: 'Sin automatización',
  costo: 'Si parás vos, para el negocio'
}];
export function CostOfInaction() {
  return <section className="w-full py-12 px-4 bg-base" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <div className="text-center mb-12" data-id="element-66">
          <h2 className="text-3xl md:text-4xl font-extrabold text-text-main flex items-center justify-center gap-3" data-id="element-67">
            <span data-id="element-68">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-alt rounded-2xl border border-red-500/20 overflow-hidden" data-id="element-69">
          <div className="grid grid-cols-2 p-4 md:p-6 border-b border-red-500/20 bg-base/50 text-sm md:text-base font-bold" data-id="element-70">
            <div className="text-text-muted" data-id="element-71">Sin Kit Pack</div>
            <div className="text-red-400" data-id="element-72">Costo real</div>
          </div>

          <div className="divide-y divide-red-500/10" data-id="element-73">
            {rows.map((row, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`grid grid-cols-2 p-4 md:p-6 text-sm md:text-base items-center ${i % 2 === 0 ? 'bg-alt' : 'bg-base'}`} data-id="element-74">
                <div className="text-text-muted pr-4" data-id="element-75">{row.sin}</div>
                <div className="text-text-main font-medium" data-id="element-76">{row.costo}</div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}